import Unidades from "@/api/Unidades";

export const unidades = {
    state: () => ({
    }),
    mutations: {
    },
    getters: {
    },
    actions: {
        async createUnidades(params, fields) {
            return new Promise((resolve, reject) => {
                Unidades.create(fields)
                    .then(response => {
                        resolve(response);
                    }).catch(err => {
                        reject(err);
                    });
            });
        },
        async getListUnidades() {
            return new Promise((resolve, reject) => {
                Unidades.getList()
                    .then(response => {
                        resolve(response);
                    }).catch(err => {
                        reject(err);
                    });
            });
        },
        async deleteUnidades(params, fields){
            return new Promise((resolve, reject) => {
                Unidades.deleteUnidades(fields)
                    .then(response => {
                        resolve(response);
                    }).catch(err => {
                        reject(err);
                    });
            });
        }
    }
}